import {PromocodesServiceSchema} from "@/services/PromocodesService/PromocodesService.schema";
import {PromocodeGroupsServiceSchema} from "@/services/PromocodeGroupsService/PromocodeGroupsService.schema";
import {generateHash} from "@/utils/generateHash";

const getResource = (input, resource) => {
    switch (input) {
        case 'promocodes':
            return {
                ...PromocodesServiceSchema,
                ...resource,
                hash: generateHash(),
                event: {...resource.event, tickets: resource.event.tickets || []} || {},
                promocodeGroup: resource.promocodeGroup || {},
                isLoading: false,
            }
        case 'groups':
            return {
                ...PromocodeGroupsServiceSchema,
                ...resource,
                hash: generateHash(),
                isLoading: false
            }
        default:
            return {}
    }
}

const getInclude = (input) => {
    switch (input) {
        case 'promocodes':
            return {
                resource: [
                    'event',
                    'event.tickets',
                    'foreign-events',
                    'foreign-events.tickets',
                    'promocode-group',
                    'tickets'
                ],
                resources: [
                    'event',
                    'promocode-group'
                ],
            }
        case 'groups':
            return {
                resource: [
                    'event',
                    'event.tickets',
                    'promocodes',
                    'promocodes.event',
                    'promocodes.event.tickets',
                    'promocodes.foreign-events',
                    'promocodes.foreign-events.tickets',
                    'promocodes.tickets'
                ],
                resources: [
                    'event'
                ],
            }
        default:
            return {resource: [], resources: []}
    }
}

export const PromocodesInternal = {getResource, getInclude}
